export default __webpack_public_path__ + "static/media/govato-tools-sign-up.7f039381.png";